import { ReactNode } from "react"

export const ShiftRateCardWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 items-stretch">
      {children}
    </div>
  )
}
